import {
  Row,
  Col,
  Form,
  Select,
  Transfer,
  Table,
  DatePicker,
  Button,
  Checkbox
} from 'antd'
import * as yup from 'yup'
import { Formik } from 'formik'
import React, { Component, Fragment } from 'react'
import LangContext from 'modules/shared/context/langContext'
import difference from 'lodash/difference'
import moment from 'moment'
import { select } from 'redux-saga/effects'
import { all } from 'gensync'

const { Option } = Select
const { RangePicker } = DatePicker

const TableTransfer = ({ leftColumns, rightColumns, ...restProps }) => (
  <div id="finding-btn">
    <Transfer
      {...restProps}
      showSelectAll={false}
      titles={[
        <div
          onClick={() => {
            restProps.onChange(restProps.dataSource.map(item => item.key))
          }}
          className="select-all-tranfers-data"
        >
          <LangContext.Consumer>
            {i18n => i18n.c.chooseAll}
          </LangContext.Consumer>
        </div>,
        <div
          onClick={() => {
            restProps.onChange([])
          }}
          className="select-all-tranfers-data"
        >
          <LangContext.Consumer>
            {i18n => i18n.c.chooseAll}
          </LangContext.Consumer>
        </div>,
      ]}
    >
      {({
        direction,
        filteredItems,
        onItemSelectAll,
        onItemSelect,
        selectedKeys: listSelectedKeys,
        disabled: listDisabled,
      }) => {
        const columns = direction === 'left' ? leftColumns : rightColumns

        const rowSelection = {
          getCheckboxProps: item => ({
            disabled: listDisabled || item.disabled,
          }),
          onSelectAll(selected, selectedRows) {
            const treeSelectedKeys = selectedRows
              .filter(item => !item.disabled)
              .map(({ key }) => key)
            const diffKeys = selected
              ? difference(treeSelectedKeys, listSelectedKeys)
              : difference(listSelectedKeys, treeSelectedKeys)
            onItemSelectAll(diffKeys, selected)
          },
          onSelect({ key }, selected) {
            onItemSelect(key, selected)
          },
          selectedRowKeys: listSelectedKeys,
        }

        return (
          <Table
            scroll={{ y: 340 }}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredItems}
            size="small"
            pagination={{ defaultPageSize: 100 }}
            style={{ pointerEvents: listDisabled ? 'none' : null }}
            onRow={({ key, disabled: itemDisabled }) => ({
              onClick: () => {
                if (itemDisabled || listDisabled) return
                onItemSelect(key, !listSelectedKeys.includes(key))
              },
            })}
          />
        )
      }}
    </Transfer>
  </div>
)

export default class Forms extends Component {
  state = {
    vehicleLists: [],
    vehicleSelect: [],
    list_vehicle_id: [],
    select_division: "all",
    select_department: "all",
    select_section: "all",
    selection_plant: ["all"],
    select_vehiclegroup: "all"
  }

  handleFormatVehicle = arrVehi => {
    let newArrVehi = arrVehi.map(v => {
      return { key: v.id, name: v.plate_no }
    })
    return newArrVehi
  }

  createSelectOption = items => {
    return items.map(ele => (
      <Option value={ele.id} key={ele.id}>
        {ele.name}
      </Option>
    ))
  }

  createSelectAll = () => {
    return (
      <Select.Option value="all">
        <LangContext.Consumer>{i18n => i18n.a.all}</LangContext.Consumer>
      </Select.Option>
    )
  }

  componentDidMount() {
    const { call } = this.props

    if (call === 'schedule') {
      if (this.props.dataedit !== '') {
        let obj = JSON.parse(this.props.dataedit)

        let divObj = this.props.division.find(x => x.name === obj.division_name);
        let depObj = this.props.department.find(x => x.name === obj.department_name);
        let secObj = this.props.section.find(x => x.name === obj.section_name);

        // 1. ตัด string เป็น array: ["a", "v", "b"]
        const plantNamesArray = obj.plant_name.split(",");

        // 2. ค้นหาใน this.props.plant (ข้อมูลต้นทาง) ว่าตัวไหนชื่อตรงกับใน array บ้าง
        const matchedPlantIds = this.props.plant
          .filter(p => plantNamesArray.includes(p.name)) // กรองเอาเฉพาะอันที่ชื่อตรงกัน
          .map(p => p.id); // ดึงเอาเฉพาะ id ออกมา

        const finalPlantIds = matchedPlantIds.length > 0 ? matchedPlantIds : ['all'];

        this.setState({
          list_vehicle_id: obj.vehicle_list || [],
          // ถ้าหา Object เจอให้ใช้ .id ถ้าไม่เจอให้ใช้ค่าเดิมจาก obj หรือ 'all'
          select_division: divObj ? divObj.id : (obj.division || 'all'),
          select_department: depObj ? depObj.id : (obj.department || 'all'),
          select_section: secObj ? secObj.id : (obj.section || 'all'),
          selection_plant: finalPlantIds,
        }, async () => {
          const { select_division, select_department, select_section, selection_plant, select_vehiclegroup } = this.state

          await this.props.handleChangeState('division', select_division)
          await this.props.handleChangeState('department', select_department)
          await this.props.handleChangeState('section', select_section)
          await this.props.handleChangeState('plant', selection_plant)
          //await this.props.handleChangeState('vehiclegroup', select_vehiclegroup)
        });
      }
    }
    let btn = document.getElementById('finding-btn').querySelectorAll('button')
    this.Leftbtn = btn[0]
    this.Rightbtn = btn[1]
  }

  componentDidUpdate(prevProps, prevState) {
    let btn = document.getElementById('finding-btn')
    if (btn !== null) {
      let botton = btn.querySelectorAll('button')
      this.Leftbtn = botton[0]
      this.Rightbtn = botton[1]
    }
  }

  tranferChange = (targetKeys, setFieldValue) => {
    setFieldValue('list_vehicle_id', targetKeys)
    this.setState({ vehicleSelect: targetKeys, list_vehicle_id: targetKeys })
  }

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState(
      {
        selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys],
      },
      () => {
        if (targetSelectedKeys.length === 0) {
          this.Leftbtn.click()
        } else {
          this.Rightbtn.click()
        }
      },
    )
  }

  handleMenuClick = (setFieldValue, handleSubmit, typeFile) => {
    setFieldValue('file_type', typeFile, false)
    handleSubmit()
  }
  handleDateFormat = value => {
    const new_format = moment(value['_d']).format('YYYY-MM-DD HH:mm:ss')
    return new_format
  }

  handleFilterValues = (val, fliterArr) => {
    let keysArr = Object.entries(val)
    let fliteredValue = Object.fromEntries(
      keysArr.filter(([key, value]) => {
        return !fliterArr.includes(key)
      }),
    )

    return fliteredValue
  }

  handleSeachVehicle = (inputValue, item) => {
    let check = item.name.toUpperCase().indexOf(inputValue.toUpperCase())
    if (check !== -1) return check
    return item.key.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
  }

  render() {
    function disabledDate(current) {
      return current && current > moment().endOf('day')
    }
    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={{
            division: this.state.select_division,
            department: this.state.select_department,
            section: this.state.select_section,
            plant: this.state.selection_plant,
            vehicleGroup: this.state.select_vehiclegroup,
            list_vehicle_id: this.state.list_vehicle_id,
            special_filter: this.props.specialFilter,
            // division: this.props.selectedDivision,
            // department: this.props.selectedDepartment,
            // section: this.props.selectedSection,
            //plant: this.props.selectedPlant,
            // vehicleGroup: this.props.selectedVehicleGroup,
            eventdate: [
              moment()
                .hours(0)
                .minutes(0)
                .seconds(0),
              moment()
                .hours(23)
                .minutes(59)
                .seconds(59),
            ],
          }}
          validationSchema={yup.object().shape({
            eventdate: yup.array().required('กรุณาเลือกช่วงวันที่'),
            list_vehicle_id: yup.array().required('กรุณาเลือก'),
          })}
          onSubmit={values => {
            values.date_start = this.handleDateFormat(values.eventdate[0])
            values.date_end = this.handleDateFormat(values.eventdate[1])

            this.props.onSubmit(values)
          }}
          render={({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldValue,
          }) => {

            return <Row type="flex" justify="center">
              <LangContext.Consumer>
                {i18n => (
                  <Form onSubmit={handleSubmit}>
                    <div className="semi-bold-16">
                      <LangContext.Consumer>
                        {i18n => i18n.o.outsidePoint}
                      </LangContext.Consumer>
                    </div>
                    <Form.Item
                      label={
                        <LangContext.Consumer>
                          {i18n => i18n.d.division}
                        </LangContext.Consumer>
                      }
                    >
                      <Select
                        value={values.division}
                        onSelect={v => {
                          setFieldValue('division', v)
                          setFieldValue('department', 'all')
                          setFieldValue('section', 'all')
                          setFieldValue('plant', ['all'])
                          setFieldValue('vehicleGroup', 'all')
                          setFieldValue('list_vehicle_id', [])

                          this.setState({
                            select_division: v,
                            select_vehiclegrou: "all",
                            select_department: "all",
                            select_section: "all",
                            selection_plant: ["all"],
                            list_vehicle_id: []
                          })

                          this.props.handleChangeState('division', v)
                        }}
                      >
                        {this.createSelectAll()}
                        {this.createSelectOption(this.props.division)}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={
                        <LangContext.Consumer>
                          {i18n => i18n.d.department}
                        </LangContext.Consumer>
                      }
                    >
                      <Select
                        value={values.department}
                        onSelect={v => {
                          setFieldValue('department', v)
                          setFieldValue('section', 'all')
                          setFieldValue('vehicleGroup', 'all')
                          setFieldValue('plant', ['all'])
                          setFieldValue('list_vehicle_id', [])

                          this.setState({
                            select_department: v,
                            select_vehiclegrou: "all",
                            select_section: "all",
                            selection_plant: ["all"],
                            list_vehicle_id: []
                          })
                          this.props.handleChangeState('department', v)
                        }}
                      >
                        {this.createSelectAll()}
                        {this.createSelectOption(this.props.department)}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={
                        <LangContext.Consumer>
                          {i18n => i18n.s.section}
                        </LangContext.Consumer>
                      }
                    >
                      <Select
                        value={values.section}
                        onSelect={v => {
                          setFieldValue('section', v)
                          setFieldValue('plant', ['all'])
                          setFieldValue('vehicleGroup', 'all')
                          setFieldValue('list_vehicle_id', [])
                          this.setState({
                            select_section: v,
                            select_vehiclegrou: "all",
                            selection_plant: ["all"],
                            select_vehiclegrou: "all",
                            list_vehicle_id: []
                          })
                          this.props.handleChangeState('section', v)
                        }}
                      >
                        {this.createSelectAll()}
                        {this.createSelectOption(this.props.section)}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={
                        <LangContext.Consumer>
                          {i18n => i18n.p.plants}
                        </LangContext.Consumer>
                      }
                    >
                      <Select
                        value={values.plant}
                        mode="multiple"
                        onChange={e => {
                          let val = e
                          if (e.length > 1 && e.includes('all')) {
                            val = e.filter(
                              (x, i) => (x === 'all' && i === 0) === false,
                            )
                          }

                          if (e.length === 0) {
                            val = 'all'
                          }

                          if (val.length > 1 && e.includes('all')) {
                            val = e.filter(x => x === 'all')
                          }

                          setFieldValue('plant', val)
                          setFieldValue('vehicleGroup', 'all')
                          setFieldValue('list_vehicle_id', [])

                          this.props.handleChangeState('plant', val)

                          this.setState({
                            selection_plant: val,
                            select_vehiclegroup: "all",
                            list_vehicle_id: []
                          })
                        }}
                        filterOption={(input, option) =>
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0 ||
                          option.props.value
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {this.createSelectAll()}
                        {this.createSelectOption(this.props.plant)}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={
                        <LangContext.Consumer>
                          {i18n => i18n.v.vehicleGroup}
                        </LangContext.Consumer>
                      }
                    >
                      <Select
                        value={values.vehicleGroup}
                        onSelect={v => {
                          setFieldValue('vehicleGroup', v)
                          this.setState({ select_vehiclegroup: v, list_vehicle_id: [] })

                          this.props.handleChangeState('vehiclegroup', v)
                        }}
                      >
                        {this.createSelectAll()}
                        {this.createSelectOption(this.props.vehicleGroup)}
                      </Select>
                    </Form.Item>

                    <Fragment>
                      <Form.Item>
                        <Checkbox
                          checked={values.special_filter === "Y"}
                          onChange={e => {
                            let value = (e.target.checked) ? "Y" : "N"
                            setFieldValue('list_vehicle_id', [])
                            setFieldValue("special_filter", value);

                            this.setState({ list_vehicle_id: [] })

                            this.props.handleChangeState('special_filter', value)
                          }}
                        >
                          <LangContext.Consumer>
                            {i18n => i18n.f.filterOutByConditionsBelow}
                          </LangContext.Consumer>
                        </Checkbox>
                      </Form.Item>
                      <Form.Item>
                        <LangContext.Consumer>
                          {i18n => (
                            <>
                              <span>1. {i18n.f.franchiseFactoryData}</span><br />
                              <span>2. {i18n.d.distanceOutsideSiteToRadiusLessThan1km}</span><br />
                              <span>3. {i18n.c.concretePourTimeLessThan2Min}</span><br />
                              <span>4. {i18n.s.speedDuringDischargeMoreThan10}</span><br />
                            </>
                          )}
                        </LangContext.Consumer>
                      </Form.Item>
                    </Fragment>

                    <Form.Item
                      label={
                        <LangContext.Consumer>
                          {i18n => i18n.v.vehicle}
                        </LangContext.Consumer>
                      }
                      validateStatus={
                        touched.list_vehicle_id &&
                        errors.list_vehicle_id &&
                        'warning'
                      }
                      help={touched.list_vehicle_id && errors.list_vehicle_id}
                    >
                      <div style={{ width: '750px' }}>
                        <TableTransfer
                          name="list_vehicle_id"
                          showSearch
                          dataSource={this.handleFormatVehicle(
                            this.props.vehicles,
                          )}
                          leftColumns={[
                            {
                              dataIndex: 'name',
                              title: (
                                <LangContext.Consumer>
                                  {i18n => i18n.i.itemLeft}
                                </LangContext.Consumer>
                              ),
                              posiction: 'Left',
                            },
                          ]}
                          rightColumns={[
                            {
                              dataIndex: 'name',
                              title: (
                                <LangContext.Consumer>
                                  {i18n => i18n.i.itemSelected}
                                </LangContext.Consumer>
                              ),
                              posiction: 'Right',
                            },
                          ]}
                          filterOption={(inputValue, item) => {
                            return (
                              item.name
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            )
                          }}
                          onChange={v => {
                            this.tranferChange(v, setFieldValue)
                          }}
                          onSelectChange={this.handleSelectChange}
                          targetKeys={values.list_vehicle_id}
                        />
                      </div>
                    </Form.Item>
                    {this.props.call === 'schedule' ? null : (
                      <Form.Item
                        required
                        label={
                          <LangContext.Consumer>
                            {i18n => i18n.d.dateRange}
                          </LangContext.Consumer>
                        }
                      >
                        <RangePicker
                          disabledDate={disabledDate}
                          value={values.eventdate}
                          onChange={v => {
                            setFieldValue('eventdate', v)
                          }}
                          format="DD/MM/YYYY HH:mm"
                          showTime={{ format: 'HH:mm' }}
                        ></RangePicker>
                      </Form.Item>
                    )}

                    <Row gutter={[8, 8]}>
                      {this.props.call === 'schedule' ? (
                        <Col span={8} style={{ marginTop: '10px' }}>
                          <Button type="primary" htmlType="submit" block>
                            <LangContext.Consumer>
                              {i18n => i18n.s.save}
                            </LangContext.Consumer>
                          </Button>
                        </Col>
                      ) : (
                        <>
                          <Col span={8}>
                            <Button type="defualt" block>
                              <LangContext.Consumer>
                                {i18n => i18n.c.cancel}
                              </LangContext.Consumer>
                            </Button>
                          </Col>
                          <Col span={8}>
                            <Button
                              type="primary"
                              onClick={() =>
                                this.handleMenuClick(
                                  setFieldValue,
                                  handleSubmit,
                                  'preview',
                                )
                              }
                              block
                            >
                              <LangContext.Consumer>
                                {i18n => i18n.p.preview}
                              </LangContext.Consumer>
                            </Button>
                          </Col>
                          <Col span={8}>
                            <Button
                              type="primary"
                              onClick={() =>
                                this.handleMenuClick(
                                  setFieldValue,
                                  handleSubmit,
                                  'excel',
                                )
                              }
                              block
                            >
                              <LangContext.Consumer>
                                {i18n => i18n.r.report}
                              </LangContext.Consumer>
                            </Button>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Form>
                )}
              </LangContext.Consumer>
            </Row>
          }}
        ></Formik>
      </Fragment>
    )
  }
}
